import { compose, componentFromProp, defaultProps, withProps } from "recompose";

export default compose(
  withProps(({ item: { __typename }, types }) => ({
    component: types[__typename] || "div",
  }))
)(componentFromProp("component"));



// WEBPACK FOOTER //
// ./src/utils/ComponentForType.js